export default __webpack_public_path__ + "static/gg-df31e60d2edce81e86a820f18e6cc5dc.png";